<template>
  <div
    class="section-wrapper"
    :class="[
      { 'section-wrapper--last': isLastSection },
      `section-wrapper--${section.name}`
    ]"
  >
    <section class="section">
      <div class="content section-enter-animation-mobile">
        <TitleComponent
          :title="section.title"
          :subtitle="section.subtitle"
          :reverse-colors="section.reverseTitleColors"
        />

        <!-- mobile img -->
        <div
          :style="{ backgroundImage: `url('${section.mobileImage}')` }"
          class="img-wrapper"
        />

        <img
          :src="section.mobileImage"
          alt=""
          class="hidden"
          @load="onMobileImgLoad"
        />
        <!-- e/o mobile img -->

        <!-- links -->

        <!-- homepage router links for 404-->
        <router-link
          v-if="section.name === '404'"
          :to="{ name: 'home' }"
          class="link"
        >
          {{ section.linkTitle }}
        </router-link>
        <!-- e/o homepage router links for 404-->

        <!-- standard links -->
        <a
          v-else-if="!isLastSection"
          :href="section.link"
          class="link"
          :target="section.targetBlank ? '_blank' : false"
          @click="handleLinkClick"
        >
          {{ section.linkTitle }}
        </a>
        <!-- e/o standard links -->

        <!-- buttons for last section -->
        <div v-else class="buttons">
          <button
            class="button button--ingredients"
            @click="$store.commit('togglePopup', 'ingredients')"
          >
            składniki i wartości odżywcze
          </button>

          <button
            class="button button--contact"
            @click="$store.commit('togglePopup', 'contact')"
          >
            Napisz do nas
          </button>
        </div>
        <!-- e/o links for last section -->
        <!-- e/o links -->
      </div>

      <!-- desktop animation -->
      <ImagesSection :section="section" />
      <!-- e/o desktop animation -->
    </section>
  </div>
</template>

<script>
import TitleComponent from '@/components/common/Title'
import ImagesSection from './ImagesSection'

export default {
  components: {
    TitleComponent,
    ImagesSection
  },
  props: {
    section: {
      type: Object,
      required: true
    },
    isLogoVisible: {
      type: Boolean,
      default: true
    },
    isLastSection: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onMobileImgLoad() {
      if (window.innerWidth < 1170) {
        this.$emit('loadedImgMobile')
      }
    },
    handleLinkClick(evt) {
      if (this.section.withLinkTransition) evt.preventDefault()
      else return

      document.body.classList.add('fade-out')
      setTimeout(() => {
        window.location = evt.target.href
      }, 500)
    }
  }
}
</script>

<style lang="scss" scoped>
.section-wrapper {
  width: 100vw;
  height: $vh;

  background: $background-color;
}

.logo {
  @include hide-down(lg);
  position: absolute;
  top: 50px;
  left: 5vw;

  opacity: 1;
  transition-delay: unset;

  &--hidden {
    opacity: 0;
    pointer-events: none;
    transition: opacity 0s 1.2s;
    // delay from gsap animation time
  }
}

.section {
  width: 100vw;
  height: 100%;
  overflow-y: hidden;

  @include media-up(lg) {
    display: flex;
    padding: 130px 18vw 160px;
    overflow-y: unset;

    .section-wrapper--loteria & {
      padding: 130px 14vw 160px;
    }

    .section-wrapper--znani & {
      padding: 130px 12vw 160px;
    }

    .section-wrapper--loteria-zdrapkowa & {
      .content {
        flex-basis: 82%;
      }
    }
  }

  @include media-up(xl) {
    display: flex;
    padding: 190px 15vw 250px;
  }
}

.content {
  height: 100%;

  display: flex;
  flex-direction: column;
  justify-content: space-between;

  padding: 90px 20px 20px;

  @include media-up(md) {
    padding: 185px 45px 40px;
  }

  @include media-up(lg) {
    padding: 0;
    justify-content: center;
    flex-basis: 50%;
    margin-right: 50px;
  }

  @include media-up(xl) {
    margin-right: 25px;
  }

  .section-wrapper--loteria & {
    .img-wrapper {
      background-position: center;
      @include media-down(md) {
        flex-grow: initial;
        height: 50%;
      }
    }

    @include media-up(lg) {
      flex-basis: 115%;
    }

    @include media-up(xl) {
      flex-basis: 140%;
    }
  }

  .section-wrapper--znani & {
    .img-wrapper {
      @include media-down(lg) {
        background-position: center;
        max-height: 273px;
      }

      @include media-down(md) {
        max-height: 139px;
      }
    }
  }

  .section-wrapper--loteria-zdrapkowa & {
    .img-wrapper {
      @include media-down(lg) {
        background-position: center;
        transform: translateX(8%);
        margin: 10px 0;
      }

      @include media-down(md) {
        background-position: right;
        margin: 30px 0;
      }
    }
  }
}

.img-wrapper {
  @include hide-up(lg);

  height: 100%;
  max-height: 450px;
  max-width: 100%;
  flex-grow: 1;

  background-repeat: no-repeat;
  background-size: contain;
  background-position: left center;

  margin: 30px 0;

  @include media-up(md) {
    margin: 60px 0;
    max-height: unset;
  }
}

.hidden {
  @include visually-hidden;
}

.link,
.button {
  @include reset-button;
  @include link;
}

.buttons {
  display: flex;

  @include media-up(xl) {
    max-width: 600px;
  }
}

.button {
  &::after {
    max-width: unset;
    width: 300px;

    @include media-down(xl) {
      width: 200px;
    }
  }

  &--contact {
    @include hide-down(lg);
    flex-grow: 1;
    text-align: center;

    &::after {
      width: 136px;
      left: calc(50% - 68px);

      @include media-down(xl) {
        width: 90px;
        left: calc(50% - 45px);
      }
    }
  }
}
</style>
